import { render, staticRenderFns } from "./NewCsatTable.vue?vue&type=template&id=d5d9a6d8&scoped=true&"
import script from "./NewCsatTable.vue?vue&type=script&lang=js&"
export * from "./NewCsatTable.vue?vue&type=script&lang=js&"
import style0 from "./NewCsatTable.vue?vue&type=style&index=0&id=d5d9a6d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d9a6d8",
  null
  
)

export default component.exports